// UNDER CONSTRUCTION

let user = null;

export default {

    init() {
        user = null;
    },
    isInternalUser() {
        try {
            const user = JSON.parse(localStorage.getItem("user"));
            return Boolean(user?.internal_user);
        } catch {
            return false;
        }
    },
    isInternalAdmin() {
        try {
            const user = JSON.parse(localStorage.getItem("user"));
            return Boolean(user?.internal_user && user?.internal_admin);
        } catch {
            return false;
        }
    },
    hasRole(permission) {
        try {
            const user = JSON.parse(localStorage.getItem("user"));
            const roles = Array.isArray(user?.roles) ? user.roles : [];
            return roles.includes(permission);
        } catch {
            return false;
        }
    },
    isCustomerService() {
        return (this.hasRole('CUSSER'));
    },












    
    isAccountManager() {
        user = JSON.parse(localStorage.getItem("user"));
        return user && user.accountManagers && user.accountManagers.includes(user.userId);
    },
    
    getManagementAccess() {
        return (this.hasRole('SADMIN') || this.hasRole('ADMIN') || this.hasRole('KAM'));
    },
    getAdministratorAccess() {
        return (this.hasRole('SADMIN') || this.hasRole('ADMIN'));
    },
    getUserAccess() {
        return false;
    },




























    

    // Customers
    getCustomerAccess() {
        return (this.hasRole('SADMIN') || this.hasRole('ADMIN') || this.hasRole('KAM') || this.hasRole('ACCMAN') || this.hasRole('ADMIN3PL') ||
                this.hasRole('USER3PL') || this.hasRole('GUEST3PL'));
    },

        // Orders
        getReadCustomerOrders() {
            return (this.hasRole('SADMIN') || this.hasRole('ADMIN') || this.hasRole('KAM') || this.hasRole('ACCMAN') || this.hasRole('ADMIN3PL') ||
                    this.hasRole('USER3PL') || this.hasRole('GUEST3PL'));
        },
        getAddCustomerOrders() {
            return (this.hasRole('SADMIN') || this.hasRole('ADMIN') || this.hasRole('KAM') || this.hasRole('ACCMAN') || this.hasRole('ADMIN3PL'));
        },
        getEditCustomerOrders() {
            return (this.hasRole('SADMIN') || this.hasRole('ADMIN') || this.hasRole('KAM') || this.hasRole('ACCMAN') || this.hasRole('ADMIN3PL'));
        },
        getCloneCustomerOrders() {
            return (this.hasRole('SADMIN') || this.hasRole('ADMIN') || this.hasRole('KAM') || this.hasRole('ACCMAN') || this.hasRole('ADMIN3PL'));
        },
        getChangeActiveStatusCustomerOrders() {
            return (this.hasRole('SADMIN') || this.hasRole('ADMIN') || this.hasRole('KAM') || this.hasRole('ACCMAN') || this.hasRole('ADMIN3PL') ||
                    this.hasRole('USER3PL'));
        },
        getDeleteCustomerOrders() {
            return (this.hasRole('SADMIN') || this.hasRole('ADMIN') || this.hasRole('KAM') || this.hasRole('ACCMAN') || this.hasRole('ADMIN3PL'));
        },
        getRecoverCustomerOrders() {
            return (this.hasRole('SADMIN') || this.hasRole('ADMIN') || this.hasRole('KAM') || this.hasRole('ACCMAN') || this.hasRole('ADMIN3PL'));
        },
        // Shipments
        getReadCustomerShipments() {
            return (this.hasRole('SADMIN') || this.hasRole('ADMIN') || this.hasRole('KAM') || this.hasRole('ACCMAN') || this.hasRole('ADMIN3PL') ||
                    this.hasRole('USER3PL') || this.hasRole('GUEST3PL'));
        },
        getViewCustomerShipmentsTracking() {
            return (this.hasRole('SADMIN') || this.hasRole('ADMIN') || this.hasRole('KAM') || this.hasRole('ACCMAN') || this.hasRole('ADMIN3PL') ||
                    this.hasRole('USER3PL'));
        },
        exportCustomerShipments() {
            return (this.hasRole('SADMIN') || this.hasRole('ADMIN') || this.hasRole('KAM') || this.hasRole('ACCMAN') || this.hasRole('ADMIN3PL') ||
                    this.hasRole('USER3PL'));
        },
        // Returns
        getReadCustomerReturns() {
            return (this.hasRole('SADMIN') || this.hasRole('ADMIN') || this.hasRole('KAM') || this.hasRole('ACCMAN') || this.hasRole('ADMIN3PL') ||
                    this.hasRole('USER3PL') || this.hasRole('GUEST3PL'));
        },
        getAddCustomerReturns() {
            return (this.hasRole('SADMIN') || this.hasRole('ADMIN') || this.hasRole('KAM') || this.hasRole('ACCMAN') || this.hasRole('ADMIN3PL'));
        },
        getEditCustomerReturns() {
            return (this.hasRole('SADMIN') || this.hasRole('ADMIN') || this.hasRole('KAM') || this.hasRole('ACCMAN') || this.hasRole('ADMIN3PL'));
        },
        getCloneCustomerReturns() {
            return (this.hasRole('SADMIN') || this.hasRole('ADMIN') || this.hasRole('KAM') || this.hasRole('ACCMAN') || this.hasRole('ADMIN3PL'));
        },
        getChangeActiveStatusCustomerReturns() {
            return (this.hasRole('SADMIN') || this.hasRole('ADMIN') || this.hasRole('KAM') || this.hasRole('ACCMAN') || this.hasRole('ADMIN3PL') ||
                    this.hasRole('USER3PL'));
        },
        getDeleteCustomerReturns() {
            return (this.hasRole('SADMIN') || this.hasRole('ADMIN') || this.hasRole('KAM') || this.hasRole('ACCMAN') || this.hasRole('ADMIN3PL'));
        },
        getRecoverCustomerReturns() {
            return (this.hasRole('SADMIN') || this.hasRole('ADMIN') || this.hasRole('KAM') || this.hasRole('ACCMAN') || this.hasRole('ADMIN3PL'));
        },
        importCustomerReturns() {
            return (this.hasRole('SADMIN') || this.hasRole('ADMIN') || this.hasRole('KAM') || this.hasRole('ACCMAN') || this.hasRole('ADMIN3PL') ||
                    this.hasRole('USER3PL'));
        },
        exportCustomerReturns() {
            return (this.hasRole('SADMIN') || this.hasRole('ADMIN') || this.hasRole('KAM') || this.hasRole('ACCMAN') || this.hasRole('ADMIN3PL') ||
                    this.hasRole('USER3PL'));
        },
        // Purchases
        getReadCustomerPurchases() {
            return (this.hasRole('SADMIN') || this.hasRole('ADMIN') || this.hasRole('KAM') || this.hasRole('ACCMAN') || this.hasRole('ADMIN3PL') ||
                    this.hasRole('USER3PL') || this.hasRole('GUEST3PL'));
        },
        getAddCustomerPurchases() {
            return (this.hasRole('SADMIN') || this.hasRole('ADMIN') || this.hasRole('KAM') || this.hasRole('ACCMAN') || this.hasRole('ADMIN3PL'));
        },
        getEditCustomerPurchases() {
            return (this.hasRole('SADMIN') || this.hasRole('ADMIN') || this.hasRole('KAM') || this.hasRole('ACCMAN') || this.hasRole('ADMIN3PL'));
        },
        getCloneCustomerPurchases() {
            return (this.hasRole('SADMIN') || this.hasRole('ADMIN') || this.hasRole('KAM') || this.hasRole('ACCMAN') || this.hasRole('ADMIN3PL'));
        },
        getChangeActiveStatusCustomerPurchases() {
            return (this.hasRole('SADMIN') || this.hasRole('ADMIN') || this.hasRole('KAM') || this.hasRole('ACCMAN') || this.hasRole('ADMIN3PL') ||
                    this.hasRole('USER3PL'));
        },
        getDeleteCustomerPurchases() {
            return (this.hasRole('SADMIN') || this.hasRole('ADMIN') || this.hasRole('KAM') || this.hasRole('ACCMAN') || this.hasRole('ADMIN3PL'));
        },
        getRecoverCustomerPurchases() {
            return (this.hasRole('SADMIN') || this.hasRole('ADMIN') || this.hasRole('KAM') || this.hasRole('ACCMAN') || this.hasRole('ADMIN3PL'));
        },
        importCustomerPurchases() {
            return (this.hasRole('SADMIN') || this.hasRole('ADMIN') || this.hasRole('KAM') || this.hasRole('ACCMAN') || this.hasRole('ADMIN3PL') ||
                    this.hasRole('USER3PL'));
        },
        exportCustomerPurchases() {
            return (this.hasRole('SADMIN') || this.hasRole('ADMIN') || this.hasRole('KAM') || this.hasRole('ACCMAN') || this.hasRole('ADMIN3PL') ||
                    this.hasRole('USER3PL'));
        },










        // Warehouses
        getReadCustomerWarehouses() {
            return (this.hasRole('SADMIN') || this.hasRole('ADMIN') || this.hasRole('KAM') || this.hasRole('ACCMAN') || this.hasRole('ADMIN3PL') ||
                    this.hasRole('USER3PL') || this.hasRole('GUEST3PL'));
        },
        exportCustomerWarehouses() {
            return (this.hasRole('SADMIN') || this.hasRole('ADMIN') || this.hasRole('KAM') || this.hasRole('ACCMAN') || this.hasRole('ADMIN3PL') ||
                    this.hasRole('USER3PL'));
        },
        // BatchUploads
        getReadCustomerBatchUploads() {
            return (this.hasRole('SADMIN') || this.hasRole('ADMIN') || this.hasRole('KAM') || this.hasRole('ACCMAN') || this.hasRole('ADMIN3PL') ||
                    this.hasRole('USER3PL') || this.hasRole('GUEST3PL'));
        },
        getDeleteCustomerBatchUploads() {
            return (this.hasRole('SADMIN') || this.hasRole('ADMIN') || this.hasRole('KAM') || this.hasRole('ACCMAN') || this.hasRole('ADMIN3PL'));
        },

        // Master Data
        getCustomerMasterDataAccess() {
            return (this.hasRole('SADMIN') || this.hasRole('ADMIN') || this.hasRole('KAM') || this.hasRole('ACCMAN') || this.hasRole('ADMIN3PL') ||
                    this.hasRole('USER3PL') || this.hasRole('GUEST3PL'));
        },
            // Products
            getReadCustomerProducts() {
                return (this.hasRole('SADMIN') || this.hasRole('ADMIN') || this.hasRole('KAM') || this.hasRole('ACCMAN') || this.hasRole('ADMIN3PL') ||
                        this.hasRole('USER3PL') || this.hasRole('GUEST3PL'));
            },
            getAddCustomerProducts() {
                return (this.hasRole('SADMIN') || this.hasRole('ADMIN') || this.hasRole('KAM') || this.hasRole('ACCMAN') || this.hasRole('ADMIN3PL'));
            },
            getEditCustomerProducts() {
                return (this.hasRole('SADMIN') || this.hasRole('ADMIN') || this.hasRole('KAM') || this.hasRole('ACCMAN') || this.hasRole('ADMIN3PL'));
            },
            getCloneCustomerProducts() {
                return (this.hasRole('SADMIN') || this.hasRole('ADMIN') || this.hasRole('KAM') || this.hasRole('ACCMAN') || this.hasRole('ADMIN3PL'));
            },
            getChangeActiveStatusCustomerProducts() {
                return (this.hasRole('SADMIN') || this.hasRole('ADMIN') || this.hasRole('KAM') || this.hasRole('ACCMAN') || this.hasRole('ADMIN3PL') ||
                        this.hasRole('USER3PL'));
            },
            getDeleteCustomerProducts() {
                return (this.hasRole('SADMIN') || this.hasRole('ADMIN') || this.hasRole('KAM') || this.hasRole('ACCMAN') || this.hasRole('ADMIN3PL'));
            },
            getRecoverCustomerProducts() {
                return (this.hasRole('SADMIN') || this.hasRole('ADMIN') || this.hasRole('KAM') || this.hasRole('ACCMAN') || this.hasRole('ADMIN3PL'));
            },
            importCustomerProducts() {
                return (this.hasRole('SADMIN') || this.hasRole('ADMIN') || this.hasRole('KAM') || this.hasRole('ACCMAN') || this.hasRole('ADMIN3PL') ||
                        this.hasRole('USER3PL'));
            },
            exportCustomerProducts() {
                return (this.hasRole('SADMIN') || this.hasRole('ADMIN') || this.hasRole('KAM') || this.hasRole('ACCMAN') || this.hasRole('ADMIN3PL') ||
                        this.hasRole('USER3PL'));
            },
        // Users
        getCustomerAdministrationAccess() {
            return (this.hasRole('SADMIN') || this.hasRole('ADMIN') || this.hasRole('KAM') || this.hasRole('ACCMAN') || this.hasRole('ADMIN3PL') ||
                    this.hasRole('USER3PL') || this.hasRole('GUEST3PL'));
        },
            // Users
            getReadCustomerUsers() {
                return (this.hasRole('SADMIN') || this.hasRole('ADMIN') || this.hasRole('KAM') || this.hasRole('ACCMAN') || this.hasRole('ADMIN3PL') ||
                        this.hasRole('USER3PL') || this.hasRole('GUEST3PL'));
            },
            getAddCustomerUsers() {
                return (this.hasRole('SADMIN') || this.hasRole('ADMIN') || this.hasRole('KAM') || this.hasRole('ACCMAN') || this.hasRole('ADMIN3PL'));
            },
            getEditCustomerUsers() {
                return (this.hasRole('SADMIN') || this.hasRole('ADMIN') || this.hasRole('KAM') || this.hasRole('ACCMAN') || this.hasRole('ADMIN3PL'));
            },
            getCloneCustomerUsers() {
                return (this.hasRole('SADMIN') || this.hasRole('ADMIN') || this.hasRole('KAM') || this.hasRole('ACCMAN') || this.hasRole('ADMIN3PL'));
            },
            getChangeActiveStatusCustomerUsers() {
                return (this.hasRole('SADMIN') || this.hasRole('ADMIN') || this.hasRole('KAM') || this.hasRole('ACCMAN') || this.hasRole('ADMIN3PL') ||
                        this.hasRole('USER3PL'));
            },
            getDeleteCustomerUsers() {
                return (this.hasRole('SADMIN') || this.hasRole('ADMIN') || this.hasRole('KAM') || this.hasRole('ACCMAN') || this.hasRole('ADMIN3PL'));
            },
            getRecoverCustomerUsers() {
                return (this.hasRole('SADMIN') || this.hasRole('ADMIN') || this.hasRole('KAM') || this.hasRole('ACCMAN') || this.hasRole('ADMIN3PL'));
            },
            importProducts() {
                return (this.hasRole('SADMIN') || this.hasRole('ADMIN') || this.hasRole('KAM') || this.hasRole('ACCMAN') || this.hasRole('ADMIN3PL') ||
                        this.hasRole('USER3PL'));
            },
            exportCustomerUsers() {
                return (this.hasRole('SADMIN') || this.hasRole('ADMIN') || this.hasRole('KAM') || this.hasRole('ACCMAN') || this.hasRole('ADMIN3PL') ||
                        this.hasRole('USER3PL'));
            },


        


            















    // Administration
    getGeneralManagementAccess() {
        return (this.hasRole('SADMIN') || this.hasRole('ADMIN') || this.hasRole('KAM') || this.hasRole('ACCMAN'));
    },
        // Master Data
        getMasterDataAccess() {
            return (this.hasRole('SADMIN') || this.hasRole('ADMIN') || this.hasRole('KAM') || this.hasRole('ACCMAN'));
        },
            // Countries
            getReadCountries() {
                return (this.hasRole('SADMIN') || this.hasRole('ADMIN') || this.hasRole('KAM') || this.hasRole('ACCMAN'));
            },
            getAddCountries() {
                return (this.hasRole('SADMIN') || this.hasRole('ADMIN') || this.hasRole('KAM'));
            },
            getEditCountries() {
                return (this.hasRole('SADMIN') || this.hasRole('ADMIN') || this.hasRole('KAM'));
            },
            getCloneCountries() {
                return (this.hasRole('SADMIN') || this.hasRole('ADMIN') || this.hasRole('KAM'));
            },
            getChangeActiveStatusCountries() {
                return (this.hasRole('SADMIN') || this.hasRole('ADMIN') || this.hasRole('KAM'));
            },
            getDeleteCountries() {
                return (this.hasRole('SADMIN') || this.hasRole('ADMIN') || this.hasRole('KAM'));
            },
            getRecoverCountries() {
                return (this.hasRole('SADMIN') || this.hasRole('ADMIN') || this.hasRole('KAM'));
            },
            // Packagings
            getReadPackagings() {
                return (this.hasRole('SADMIN') || this.hasRole('ADMIN') || this.hasRole('KAM') || this.hasRole('ACCMAN'));
            },
            getAddPackagings() {
                return (this.hasRole('SADMIN') || this.hasRole('ADMIN') || this.hasRole('KAM'));
            },
            getEditPackagings() {
                return (this.hasRole('SADMIN') || this.hasRole('ADMIN') || this.hasRole('KAM'));
            },
            getClonePackagings() {
                return (this.hasRole('SADMIN') || this.hasRole('ADMIN') || this.hasRole('KAM'));
            },
            getChangeActiveStatusPackagings() {
                return (this.hasRole('SADMIN') || this.hasRole('ADMIN') || this.hasRole('KAM'));
            },
            getDeletePackagings() {
                return (this.hasRole('SADMIN') || this.hasRole('ADMIN') || this.hasRole('KAM'));
            },
            getRecoverPackagings() {
                return (this.hasRole('SADMIN') || this.hasRole('ADMIN') || this.hasRole('KAM'));
            },
        // Customer Data
        getCustomerDataAccess() {
            return (this.hasRole('SADMIN') || this.hasRole('ADMIN') || this.hasRole('KAM') || this.hasRole('ACCMAN'));
        },
            // Customers
            getReadCustomers() {
                return (this.hasRole('SADMIN') || this.hasRole('ADMIN') || this.hasRole('KAM') || this.hasRole('ACCMAN'));
            },
            getAddCustomers() {
                return (this.hasRole('SADMIN') || this.hasRole('ADMIN') || this.hasRole('KAM'));
            },
            getEditCustomers() {
                return (this.hasRole('SADMIN') || this.hasRole('ADMIN') || this.hasRole('KAM'));
            },
            getCloneCustomers() {
                return (this.hasRole('SADMIN') || this.hasRole('ADMIN') || this.hasRole('KAM'));
            },
            getChangeActiveStatusCustomers() {
                return (this.hasRole('SADMIN') || this.hasRole('ADMIN') || this.hasRole('KAM'));
            },
            getDeleteCustomers() {
                return (this.hasRole('SADMIN') || this.hasRole('ADMIN') || this.hasRole('KAM'));
            },
            getRecoverCustomers() {
                return (this.hasRole('SADMIN') || this.hasRole('ADMIN') || this.hasRole('KAM'));
            },
        // User Data
        getUserDataAccess() {
            return (this.hasRole('SADMIN') || this.hasRole('ADMIN') || this.hasRole('KAM') || this.hasRole('ACCMAN'));
        },
            // Users
            getReadUsers() {
                return (this.hasRole('SADMIN') || this.hasRole('ADMIN') || this.hasRole('KAM') || this.hasRole('ACCMAN'));
            },
            getAddUsers() {
                return (this.hasRole('SADMIN') || this.hasRole('ADMIN') || this.hasRole('KAM'));
            },
            getEditUsers() {
                return (this.hasRole('SADMIN') || this.hasRole('ADMIN') || this.hasRole('KAM'));
            },
            getCloneUsers() {
                return (this.hasRole('SADMIN') || this.hasRole('ADMIN') || this.hasRole('KAM'));
            },
            getChangeActiveStatusUsers() {
                return (this.hasRole('SADMIN') || this.hasRole('ADMIN') || this.hasRole('KAM'));
            },
            getDeleteUsers() {
                return (this.hasRole('SADMIN') || this.hasRole('ADMIN') || this.hasRole('KAM'));
            },
            getRecoverUsers() {
                return (this.hasRole('SADMIN') || this.hasRole('ADMIN') || this.hasRole('KAM'));
            },
};